import { MANIFESTO } from "../../data/collection";
import { Reveal } from "./Reveal";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto"
      className="relative bg-[#FDFBF7] text-[#050505]"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20 py-24 md:py-36">
        <div className="grid gap-12 md:grid-cols-12 md:gap-16">
          {/* sticky title */}
          <div className="md:col-span-4">
            <div className="md:sticky md:top-28">
              <Reveal>
                <p className="font-body text-[11px] uppercase tracking-[0.4em] text-black/40">
                  Our Ethos
                </p>
              </Reveal>
              <Reveal delay={0.05}>
                <h2 className="mt-5 font-display text-5xl md:text-6xl font-light leading-[0.95]">
                  Made the
                  <br />
                  <span className="font-serif-editorial italic text-black/70">
                    old way.
                  </span>
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="mt-6 max-w-xs font-body text-sm font-light leading-relaxed text-black/55">
                  Four promises stitched into every piece we send out into the
                  world.
                </p>
              </Reveal>
            </div>
          </div>

          {/* chapters */}
          <div className="md:col-span-8">
            {MANIFESTO.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.05}>
                <article
                  data-testid={`manifesto-${c.no}`}
                  className="grid grid-cols-[auto_1fr] gap-6 border-t border-black/15 py-10 md:gap-12 md:py-14"
                >
                  <span className="font-serif-editorial text-3xl md:text-5xl font-light text-black/30">
                    {c.no}
                  </span>
                  <div>
                    <h3 className="font-display text-4xl md:text-6xl font-light leading-none">
                      {c.title}
                    </h3>
                    <p className="mt-5 max-w-lg font-body text-sm md:text-base font-light leading-relaxed text-black/60">
                      {c.body}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
